import React from 'react';
import './Footer.css';
import ProskinsLogo from './ui/ProskinsLogo';


const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <ProskinsLogo size="large" showTagline={false} linkTo="/" />
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="/">Home</a></li>
              <li><a href="/tournaments">Tournaments</a></li>
              <li><a href="/about">About</a></li>
              <li><a href="/contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Legal</h4>
            <ul>
              <li><a href="/terms">Terms of Service</a></li>
              <li><a href="/privacy">Privacy Policy</a></li>
              <li><a href="/site-rules">Site Rules</a></li>
              <li><a href="/responsible-gaming">Responsible Gaming</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Support</h4>
            <ul>
              {/*<li><a href="/help">Help Center</a></li>
              <li><a href="/faq">FAQ</a></li>*/}
              <li><a href="/contact">Contact Support</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2025 Pro$kins LLC. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
